import HelpCenter from '@components/HelpCenter/HelpCenter'
import native from '@zz-common/native-adapter'

export default [
  {
    path: '/',
    name: 'HelloWorld',
    component(resolve) {
      require(['@components/Home/index.vue'], resolve)
    }
  },
  //  被举报历史记录
  {
    path: '/accusationhistory',
    name: 'AccusationHistory',
    component(resolve) {
      require(['@components/AccusationHistory/AccusationHistory'], resolve)
    }
  },
  //  app私信 帮助的指南
  {
    path: '/appImHelper',
    name: 'AppImHelper',
    component(resolve) {
      require(['@components/appImHelper/appImHelper'], resolve)
    }
  },
  //  客服中心
  {
    path: '/helpcenter',
    name: 'HelpCenter',
    meta: {
      auth: true,
      pageId: 'N3213',
      level: 2
    },
    component: HelpCenter
  },
  //  新客服中心
  {
    path: '/newHelpCenter',
    name: 'NewHelpCenter',
    component(resolve) {
      require(['@components/NewHelpCenter'], resolve)
    },
    meta: {
      auth: true,
      desc: '找靓机新客服中心',
      pageId: 'E5844',
      level: 2
    }
  },
  //  商家客服中心
  {
    path: '/helpcenterseller',
    name: 'HelpCenterSeller',
    component(resolve) {
      require(['@components/HelpCenter/HelpCenterSeller'], resolve)
    }
  },
  //  主程序客服中心
  {
    path: '/helpcenterwa',
    name: 'HelpCenterWA',
    meta: {
      pageId: 'W8720',
      level: 2
    },
    component(resolve) {
      require(['@components/HelpCenter/HelpCenterWA'], resolve)
    }
  },
  // 找靓机客服中心
  {
    path: '/helpcenterzlj',
    name: 'HelpCenterZlj',
    meta: {
      pageId: 'I4198',
      level: 2
    },
    component(resolve) {
      require(['@components/HelpCenter/HelpCenterZlj'], resolve)
    }
  },
  {
    path: '/zljservicelist',
    name: 'ZljServiceList',
    component(resolve) {
      require(['@components/ZLJServiceList'], resolve)
    }
  },
  //maimai 认证结果页
  {
    path: '/maimairesult',
    name: 'maimairesult',
    component(resolve) {
      require(['@components/maimairesult/maimairesult'], resolve)
    }
  },
  //  客服中心兜底页
  {
    path: '/helpcenterbackup',
    name: 'HelpCenterBackup',
    component(resolve) {
      require(['@components/HelpCenter/HelpCenterBackup'], resolve)
    }
  },
  //  VIP用户中间选择页
  {
    path: '/vipmidchoice',
    name: 'VIPMidChoice',
    component(resolve) {
      require(['@components/VIPMidChoice/VIPMidChoice'], resolve)
    }
  },
  //  实人认证提交认证信息(扫脸页面是客户端的，此处的页面为手动提交页面)
  {
    path: '/realauth/commitinfo',
    name: 'RealAuthCommitInfo',
    component(resolve) {
      require(['@components/RealAuth/CommitInfo'], resolve)
    },
    meta: {
      auth: true
    }
  },
  // 实人认证提交待审核(扫脸页面是客户端的，此处的页面为手动提交结果承载页面)
  {
    path: '/realauth/commitresult',
    name: 'RealAuthCommitResult',
    component(resolve) {
      require(['@components/RealAuth/CommitResult'], resolve)
    }
  },
  //  实人认证审核结果页(扫脸页面是客户端的，此处的页面为结果承载页面)
  {
    path: '/realauth/result',
    name: 'RealAuthResult',
    component(resolve) {
      require(['@components/RealAuth/Result'], resolve)
    }
  },
  //新实人认证（认证支持港澳台）
  {
    path: '/newrealauth/commit',
    name: 'newRealAuth',
    component(resolve) {
      require(['@components/RealAuthNew/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //实人认证修改名字
  {
    path: '/realauth/changename',
    name: 'changeName',
    component(resolve) {
      require(['@components/ChangeName/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //二次放号实名校验
  {
    path: '/realauth/realNameVerification',
    name: 'realNameVerification',
    component(resolve) {
      require(['@components/RealNameVerification'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //app实人信息完整度页面
  {
    path: '/privateinfo/status',
    name: 'privateinfo',
    component(resolve) {
      require(['@components/PrivateInfoStatusPage/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //app实人信息 证件补充
  {
    path: '/privateinfosupply/card',
    name: 'privateinfo',
    component(resolve) {
      require(['@components/PrivateInfoStatusSupply/Card/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //app实人信息 人像补充
  {
    path: '/privateinfosupply/face',
    name: 'privateinfo',
    component(resolve) {
      require(['@components/PrivateInfoStatusSupply/Face/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //app实人信息 港澳台人脸认证
  {
    path: '/privateinfosupply/hkmtface',
    name: 'privateinfoHKMTFace',
    component(resolve) {
      require(['@components/PrivateInfoStatusSupply/HKMTFace/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //全流程转转app扫脸认证（和realauth一样，只不过把客户端的扫脸也拿过来重写）
  {
    path: '/realauth/verifyface',
    name: 'verifyface',
    component(resolve) {
      require(['@components/RealAuthVerifyFace/index'], resolve)
    },
    meta: {
      auth: true
    },
    redirect: '/realauth/verifyface/verify',
    children: [
      //认证页面
      {
        path: 'verify',
        name: 'verify',
        component(resolve) {
          require(['@components/RealAuthVerifyFace/Verify/index'], resolve)
        }
      },
      //认证结果
      {
        path: 'result',
        name: 'result',
        component(resolve) {
          require(['@components/RealAuthVerifyFace/Result/index'], resolve)
        }
      },
      //认证失败主动提交
      {
        path: 'commit',
        name: 'commit',
        component(resolve) {
          require(['@components/RealAuthVerifyFace/Commit/index'], resolve)
        }
      }
    ]
  },
  //  二要素身份证验证 & 结果
  {
    path: '/IdCardAuth/CommitInfo',
    name: 'idCardAuth',
    redirect: () => {
      if (native.in('zz') || native.in('zlj')) {
        return '/IdCardAuth/CommitInfo/app'
      } else {
        return '/IdCardAuth/CommitInfo/uniapp'
      }
    }
  },
  // 二要素认证 小程序端
  {
    path: '/IdCardAuth/CommitInfo/uniapp',
    name: 'idCardAuthuniapp',
    component(resolve) {
      require(['@components/IdCardAuthUniapp/CommitInfo'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //二要素认证 转转和找靓机端
  {
    path: '/IdCardAuth/CommitInfo/app',
    name: 'idCardAuthapp',
    component(resolve) {
      require(['@components/IdCardAuthApp/CommitInfo'], resolve)
    },
    meta: {
      auth: true
    }
  },
  //  商业实人认证提交认证信息
  {
    path: '/businessrealauth/commitinfo',
    name: 'BusinessRealAuthCommitInfo',
    component(resolve) {
      require(['@components/BusinessRealAuth/CommitInfo'], resolve)
    }
  },
  //  商业实人认证-提交认证结果
  {
    path: '/businessrealauth/result',
    name: 'BusinessRealAuthResult',
    component(resolve) {
      require(['@components/BusinessRealAuth/Result'], resolve)
    }
  },
  //  商业实人认证-提交人工审核结果
  {
    path: '/businessrealauth/commitresult',
    name: 'BusinessRealAuthCommitResult',
    component(resolve) {
      require(['@components/BusinessRealAuth/CommitResult'], resolve)
    }
  },
  //  找靓机实人认证-提交页
  {
    path: '/zljrealauth/commit',
    name: 'ZLJRealAuthCommitInfo',
    component(resolve) {
      require(['@components/ZLJRealAuth/commit'], resolve)
    }
  },
  //  找靓机实人认证-结果页
  {
    path: '/zljrealauth/result',
    name: 'ZLJRealAuthResult',
    component(resolve) {
      require(['@components/ZLJRealAuth/result'], resolve)
    }
  },
  //  保证金-提交人工审核
  {
    path: '/Bond/commitinfo',
    name: 'BondCommitInfo',
    component(resolve) {
      require(['@components/Bond/CommitInfo'], resolve)
    }
  },
  //  保证金-通知页
  {
    path: '/Bond/viewinfo',
    name: 'BondViewInfo',
    component(resolve) {
      require(['@components/Bond/ViewInfo'], resolve)
    }
  },
  //  保证金-审核结果
  {
    path: '/Bond/result',
    name: 'BondResult',
    component(resolve) {
      require(['@components/Bond/Result'], resolve)
    }
  },
  //  云验货-卖家提示页
  {
    path: '/cloudInspection/sellertip',
    name: 'SellerTip',
    component(resolve) {
      require(['@components/cloudInspection/SellerTip/index'], resolve)
    }
  },
  //  云验货-游戏上传凭证示例
  {
    path: '/cloudInspection/uploadExample',
    name: 'cloudUploadExample',
    component(resolve) {
      require(['@components/cloudInspection/uploadExample/uploadExample'], resolve)
    }
  },
  //云验货-游戏校验、
  {
    path: '/cloudInspection/GameExamine',
    name: 'GameExamine',
    component(resolve) {
      require(['@components/cloudInspection/GameExamine/GameExamine'], resolve)
    }
  },
  //防骗指南
  {
    path: '/cloudInspection/PreventFoolExample',
    name: 'PreventFoolExample',
    component(resolve) {
      require(['@components/cloudInspection/PreventFoolExample/PreventFoolExample'], resolve)
    }
  },
  //防骗公告
  {
    path: '/cloudInspection/PreventFoolNotice',
    name: 'PreventFoolNotice',
    component(resolve) {
      require(['@components/cloudInspection/PreventFoolNotice/PreventFoolNotice'], resolve)
    }
  },
  //云验货校验
  {
    path: '/cloudInspection/examineInfo',
    name: 'examineInfo',
    component(resolve) {
      require(['@components/cloudInspection/examineInfo'], resolve)
    }
  },
  //云验货-无法验货
  {
    path: '/cloudInspection/UnableInspect',
    name: 'UnableInspect',
    component(resolve) {
      require(['@components/cloudInspection/UnableInspect'], resolve)
    }
  },
  //云验货-审核结果
  {
    path: '/cloudInspection/Result',
    name: 'Result',
    component(resolve) {
      require(['@components/cloudInspection/Result'], resolve)
    }
  },
  // 监督举报
  {
    path: '/supervise',
    name: 'caseHandle',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/Supervise/index'], resolve)
    }
  },
  {
    path: '/supervise/entry',
    name: 'superviseentry',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/Supervise/Entry/index'], resolve)
    }
  },
  {
    path: '/supervise/commit',
    name: 'supervisecommit',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/Supervise/Commit/index'], resolve)
    }
  },
  {
    path: '/supervise/result',
    name: 'superviseresult',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/Supervise/Result/index'], resolve)
    }
  },
  //  举报
  {
    path: '/reportreason',
    name: 'ReportReason',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/Report/index'], resolve)
    },
    redirect: '/reportreason/choosereason',
    children: [
      //选择原因
      {
        path: 'choosereason',
        name: 'choosereason',
        component(resolve) {
          require(['@components/Report/ChooseReason/index'], resolve)
        }
      },
      //欺诈流程之前
      {
        path: 'beforefraud',
        name: 'beforefraud',
        component(resolve) {
          require(['@components/Report/BeforeFraud/index'], resolve)
        }
      },
      //欺诈流程
      {
        path: 'fraud',
        name: 'fraud',
        component(resolve) {
          require(['@components/Report/Fraud/index'], resolve)
        }
      },
      //选择凭证
      {
        path: 'chooseevidence',
        name: 'chooseevidence',
        component(resolve) {
          require(['@components/Report/ChooseEvidence/index'], resolve)
        }
      },
      //举报提交
      {
        path: 'commit',
        name: 'commitreport',
        component(resolve) {
          require(['@components/Report/CommitReport/index'], resolve)
        }
      },
      //  举报资质凭证示例
      {
        path: 'uploadExample',
        name: 'uploadExample',
        component(resolve) {
          require(['@components/Report/uploadExample/uploadExample'], resolve)
        }
      },
      //  举报资质指引示例
      {
        path: 'uploadGuide',
        name: 'uploadGuide',
        component(resolve) {
          require(['@components/Report/uploadGuide/uploadGuide'], resolve)
        }
      }
    ]
  },
  // 新举报
  {
    path: '/newreport',
    name: 'NewReport',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/ReportNew/index'], resolve)
    },
    redirect: '/newreport/choosereason',
    children: [
      //选择初始原因
      {
        path: 'choosereason',
        name: 'choosereason',
        component(resolve) {
          require(['@components/ReportNew/ChooseReason/index'], resolve)
        },
        meta: {
          keepAlive: true // 不需要缓存,默认不缓存，可以不写
        }
      },
      //不诚信交易举报
      {
        path: 'fraud',
        name: 'fraud',
        component(resolve) {
          require(['@components/ReportNew/RouteFraud/index'], resolve)
        },
        redirect: '/newreport/fraud/beforefraud',
        children: [
          //欺诈流程之前
          {
            path: 'beforefraud',
            name: 'beforefraud',
            component(resolve) {
              require(['@components/ReportNew/RouteFraud/Before/index'], resolve)
            }
          },
          //欺诈流程
          {
            path: 'afterfraud',
            name: 'afterfraud',
            component(resolve) {
              require(['@components/ReportNew/RouteFraud/After/index'], resolve)
            }
          },
          //手机相关
          {
            path: 'phonerelated',
            name: 'phonerelated',
            component(resolve) {
              require(['@components/ReportNew/RouteFraud/PhoneRelated/index'], resolve)
            }
          },
          //手机提交
          {
            path: 'phonesubmit',
            name: 'phonesubmit',
            component(resolve) {
              require(['@components/ReportNew/RouteFraud/PhoneSubmit/index'], resolve)
            }
          }
        ]
      },
      //用户骚扰举报
      {
        path: 'harass',
        name: 'harass',
        component(resolve) {
          require(['@components/ReportNew/RouteHarass/index'], resolve)
        }
      },
      //商品举报
      {
        path: 'product',
        name: 'product',
        component(resolve) {
          require(['@components/ReportNew/RouteProduct/index'], resolve)
        }
      },
      //个人信息举报
      {
        path: 'person',
        name: 'person',
        component(resolve) {
          require(['@components/ReportNew/RoutePerson/index'], resolve)
        }
      },
      //涉未成年人举报
      {
        path: 'child',
        name: 'child',
        component(resolve) {
          require(['@components/ReportNew/RouteChild/index'], resolve)
        }
      },
      //破坏晴朗环境举报
      {
        path: 'environment',
        name: 'environment',
        component(resolve) {
          require(['@components/ReportNew/RouteEnvironment/index'], resolve)
        }
      }
    ]
  },
  //  举报记录
  {
    path: '/reportlist',
    name: 'ReportList',
    component(resolve) {
      require(['@components/Report/ReportList/ReportList'], resolve)
    }
  },
  //  新举报记录
  {
    path: '/newreportlist',
    name: 'newReportList',
    component(resolve) {
      require(['@components/ReportNew/ReportList/index'], resolve)
    }
  },
  //举报记录详情
  {
    path: '/ReportDetial',
    name: 'ReportDetial',
    component(resolve) {
      require(['@components/Report/ReportDetial/ReportDetial'], resolve)
    }
  },
  //新举报记录详情
  {
    path: '/newReportDetial',
    name: 'newReportDetial',
    component(resolve) {
      require(['@components/ReportNew/ReportDetial/ReportDetial'], resolve)
    }
  },
  //补充举报(此组件用于单独的补充举报页面，也可以作为其他来源的普通举报页面，此时from不为10)
  {
    path: '/ReportSupplementDetial',
    name: 'ReportSupplementDetial',
    component(resolve) {
      require(['@components/Report/ReportSupplementDetial/index'], resolve)
    }
  },
  //  离线评价
  {
    path: '/offlineevaluation',
    name: 'OfflineEvaluation',
    component(resolve) {
      require(['@components/OfflineEvaluation/OfflineEvaluation'], resolve)
    }
  },
  //  IM5颗星级离线评价 （已下线）
  // {
  //     path: '/starevaluation',
  //     name: 'StarEvaluation',
  //     component (resolve) {
  //         require(['@components/OfflineEvaluation/OfflineStarEvaluation'], resolve)
  //     }
  // },
  //  IM 三档 离线评价 ，但使用5星评价的接口
  {
    path: '/starevaluation',
    name: 'StarEvaluation',
    component(resolve) {
      require(['@components/OfflineEvaluation/OfflineThreeEvaluation'], resolve)
    }
  },
  //  工单评价
  {
    path: '/orderevaluation',
    name: 'KefuOrderEvaluation',
    component(resolve) {
      require(['@components/KefuOrderEvaluation/KefuOrderEvaluation'], resolve)
    }
  },
  //服务反馈评价-成功
  {
    path: '/orderevaluation/success',
    name: 'KefuOrderEvaluationSuccess',
    component(resolve) {
      require(['@components/KefuOrderEvaluation/Success'], resolve)
    }
  },
  //服务反馈评价-失败
  {
    path: '/orderevaluation/expired',
    name: 'KefuOrderEvaluationExpired',
    component(resolve) {
      require(['@components/KefuOrderEvaluation/Expired'], resolve)
    }
  },
  //  联系卡说明页
  {
    path: '/cardinfo',
    name: 'cardinfo',
    component(resolve) {
      require(['@components/cardinfo/cardinfo'], resolve)
    }
  },
  //  服务进度列表页面（工单详情）
  {
    path: '/serviceprocess/list',
    name: 'serviceProcessList',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/service-process/service-process-list/index'], resolve)
    }
  },
  //  服务进度详情页面（工单详情）
  {
    path: '/serviceprocess/detail/:ticketId',
    name: 'serviceProcessDetail',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/service-process/service-process-detail/index'], resolve)
    }
  },
  //  服务留言（工单详情）
  {
    path: '/serviceprocess/message',
    name: 'serviceProcessMessage',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/service-process/service-leave-message/index'], resolve)
    }
  },
  {
    path: '/loading',
    name: 'loading',
    component(resolve) {
      require(['@components/loading/loading'], resolve)
    }
  },
  {
    path: '/UploadDemo',
    name: 'UploadDemo',
    component(resolve) {
      require(['@components/UploadDemo/index'], resolve)
    }
  },
  //  安全中心（首页）
  {
    path: '/safecenter/home',
    name: 'SafeCenter',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/SafeCenter/Home'], resolve)
    }
  },
  //  安全中心（详情页）
  {
    path: '/safecenter/detial',
    name: 'SafeDetial',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/SafeCenter/Detial'], resolve)
    }
  },
  //  安全中心（平台规则）
  {
    path: '/safecenter/articlelist',
    name: 'ArticleList',
    component(resolve) {
      require(['@components/SafeCenter/ArticleList'], resolve)
    }
  },
  //  安全中心（平台规则）
  {
    path: '/safecenter/videolist',
    name: 'VideoList',
    component(resolve) {
      require(['@components/SafeCenter/VideoList'], resolve)
    }
  },
  //  赔付打款-说明页
  {
    path: '/paymoney/description',
    name: 'Description',
    component(resolve) {
      require(['@components/PayMoney/Description'], resolve)
    }
  },
  //  赔付打款-领取页
  {
    path: '/paymoney/receive',
    name: 'Receive',
    component(resolve) {
      require(['@components/PayMoney/Receive'], resolve)
    }
  },
  //  赔付打款-记录页
  {
    path: '/paymoney/history',
    name: 'History',
    component(resolve) {
      require(['@components/PayMoney/History'], resolve)
    }
  },
  //  赔付打款-详情页
  {
    path: '/paymoney/detial',
    name: 'Detial',
    component(resolve) {
      require(['@components/PayMoney/Detial'], resolve)
    }
  },
  //  赔付打款-法务详情页
  {
    path: '/paymoney/lawversion',
    name: 'LawVersion',
    component(resolve) {
      require(['@components/PayMoney/Description/LawVersion'], resolve)
    }
  },
  //  赔付打款-选择订单页
  {
    path: '/paymoney/select',
    name: 'Select',
    component(resolve) {
      require(['@components/PayMoney/Select'], resolve)
    }
  },
  //  赔付打款-提交页
  {
    path: '/paymoney/submit',
    name: 'Submit',
    component(resolve) {
      require(['@components/PayMoney/Submit'], resolve)
    }
  },
  //  赔付打款-提交成功页
  {
    path: '/paymoney/success',
    name: 'Success',
    component(resolve) {
      require(['@components/PayMoney/Submit/Success'], resolve)
    }
  },
  //  赔付打款-答题前面页
  {
    path: '/paymoney/beforequestion',
    name: 'BeforeQuestion',
    meta: {
      auth: true
    },
    component(resolve) {
      require(['@components/PayMoney/BeforeQuestion'], resolve)
    }
  },
  //  资质审核-提交营业执照页
  {
    path: '/quality/license',
    name: 'QualityLicense',
    component(resolve) {
      require(['@components/Quality/License'], resolve)
    }
  },
  //  资质审核-提交许可证页
  {
    path: '/quality/permit',
    name: 'QualityPermit',
    component(resolve) {
      require(['@components/Quality/Permit'], resolve)
    }
  },
  //  资质审核-成功页
  {
    path: '/quality/success',
    name: 'QualitySuccess',
    component(resolve) {
      require(['@components/Quality/Success'], resolve)
    }
  },
  //  资质审核-查看经营资质信息
  {
    path: '/quality/information',
    name: 'QualityInfo',
    component(resolve) {
      require(['@components/Quality/Information'], resolve)
    }
  },
  // 投诉中心（表单提交）
  {
    path: '/complaint/form',
    name: 'ComplaintForm',
    meta: {
      auth: true,
      pageId: 'S4846', // 投诉中心展现埋点
      level: 2
    },
    component(resolve) {
      require(['@components/complaint/complaint-form'], resolve)
    }
  },
  // 投诉中心（表单提交）
  // {
  //   path: '/complaint/formcopy',
  //   name: 'ComplaintFormCopy',
  //   meta: {
  //     auth: true
  //   },
  //   component(resolve) {
  //     require(['@components/complaint/complaint-form/index-backup.vue'], resolve)
  //   }
  // },

  // 投诉中心（提交成功）
  {
    path: '/complaint/success',
    name: 'ComplaintSuccess',
    component(resolve) {
      require(['@components/complaint/complaint-success'], resolve)
    }
  },
  // 意见反馈
  {
    path: '/helpcenter/feedback',
    name: 'HelpCenterFeedback',
    component(resolve) {
      require(['@components/HelpCenter/HelpCenterFeedback'], resolve)
    }
  },
  // 违规申诉
  {
    path: '/helpcenter/AccountAppeal',
    name: 'accountAppeal',
    component(resolve) {
      require(['@components/HelpCenter/HelpCenterAccountAppeal'], resolve)
    }
  },
  // 功能异常和使用建议
  {
    path: '/helpcenter/InterFeedback',
    name: 'InterFeedback',
    component(resolve) {
      require(['@components/InterFeedback/InterFeedback'], resolve)
    }
  },
  {
    path: '/interFeedback/success',
    name: 'InterFeedbackSuccess',
    component(resolve) {
      require(['@components/InterFeedback/FeedbackSuccess'], resolve)
    }
  },
  {
    path: '/serviceform',
    name: 'serviceForm',
    component(resolve) {
      require(['@components/service-form/index'], resolve)
    }
  },
  {
    path: '/serviceform/success',
    name: 'serviceFormSuccess',
    component(resolve) {
      require(['@components/service-form/service-form-success/index'], resolve)
    }
  },
  {
    path: '/serviceform/fail',
    name: 'serviceFormFail',
    component(resolve) {
      require(['@components/service-form/service-form-fail/index'], resolve)
    }
  },
  // 微信绑定
  {
    path: '/wechatauthorize',
    name: 'WechatAuthorize',
    component(resolve) {
      require(['@components/WechatAuthorize/index'], resolve)
    }
  },
  // 商品发布资质中间页
  {
    path: '/productqua',
    name: 'ProductQua',
    component(resolve) {
      require(['@components/ProductQua/index'], resolve)
    }
  },
  // 商品资质提交状态
  {
    path: '/productqua/result',
    name: 'ProductQuaResult',
    component(resolve) {
      require(['@components/ProductQua/result'], resolve)
    }
  },
  // 商品资质核验
  {
    path: '/productqua/submit',
    name: 'ProductQuaSubmit',
    component(resolve) {
      require(['@components/ProductQua/auditSubmit'], resolve)
    }
  },
  // 商品资质核验状态
  {
    path: '/productqua/status',
    name: 'ProductQuaStatus',
    component(resolve) {
      require(['@components/ProductQua/auditStatus'], resolve)
    }
  },
  // 营业执照认证-特供-无经营许可认证流程
  {
    path: '/qualityauth',
    name: 'QualityAuth',
    component(resolve) {
      require(['@components/QualityAuth/index'], resolve)
    }
  },
  // 营业执照认证-特供-无经营许可认证流程
  {
    path: '/qualityauth/license',
    name: 'QualityAuthLicense',
    component(resolve) {
      require(['@components/QualityAuth/License/index'], resolve)
    }
  },
  // 营业执照认证结果页-特供-无经营许可认证流程
  {
    path: '/qualityauth/success',
    name: 'QualityAuthSuccess',
    component(resolve) {
      require(['@components/QualityAuth/Success/index'], resolve)
    }
  },
  // 营业执照认证信息展示页-特供-无经营许可认证流程
  {
    path: '/qualityauth/checkinfo',
    name: 'QualityAuthCheckInfo',
    component(resolve) {
      require(['@components/QualityAuth/CheckInfo/index'], resolve)
    }
  },
  { //全新的资质审核，旧的仍然使用，新的整合了两个流程
    path: '/newquality',
    name: 'NewQuality',
    component(resolve) {
      require(['@components/NewQuality/index'], resolve)
    }
  },
  { //经营信息功能入口
    path: '/bussinessInfo/entry',
    name: 'BussinessInfoEntry',
    component(resolve) {
      require(['@components/BusinessInfo/Entry/index'], resolve)
    }
  },
  { //个人声明
    path: '/bussinessInfo/personDeclaration',
    name: 'BussinessInfoPersonDeclaration',
    component(resolve) {
      require(['@components/BusinessInfo/PersonDeclaration/index'], resolve)
    }
  },
  { //个人声明-他人视角
    path: '/bussinessInfo/personDeclaration/information',
    name: 'personDeclarationInformation',
    component(resolve) {
      require(['@components/BusinessInfo/PersonDeclaration/Information/index'], resolve)
    }
  },
  { //经营场所
    path: '/bussinessInfo/placeOfBusiness',
    name: 'BussinessInfoPlaceOfBusiness',
    component(resolve) {
      require(['@components/BusinessInfo/PlaceOfBusiness/index'], resolve)
    }
  },
  { //大师熊app用的身份认证页面
    path: '/masterBear/realNameAuth',
    name: 'masterBearRealNameAuth',
    component(resolve) {
      require(['@components/MasterBear/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  // 披露初始化
  {
    path: '/informationDisclosure',
    name: 'informationDisclosureInit',
    component(resolve) {
      require(['@components/InformationDisclosure/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  // 披露确认
  {
    path: '/informationDisclosure/confirm',
    name: 'informationDisclosureConfirm',
    component(resolve) {
      require(['@components/InformationDisclosure/Confirm/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  // 披露提交
  {
    path: '/informationDisclosure/commit',
    name: 'informationDisclosureCommit',
    component(resolve) {
      require(['@components/InformationDisclosure/Commit/index'], resolve)
    },
    meta: {
      auth: true
    }
  },
  // 披露结果
  {
    path: '/informationDisclosure/result',
    name: 'informationDisclosureResult',
    component(resolve) {
      require(['@components/InformationDisclosure/Result/index'], resolve)
    },
    meta: {
      auth: true
    }
  }
]